import {library} from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faAnglesDown,
  faArchive,
  faArrowDownShortWide,
  faArrowLeft,
  faArrowLeftLong,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRightLong,
  faArrowRightToBracket,
  faArrowsAltH,
  faArrowsLeftRightToLine,
  faArrowUpFromBracket,
  faAsterisk,
  faBan,
  faBars,
  faBell,
  faBook,
  faBookmark,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faChartArea,
  faChartColumn,
  faCheck,
  faCheckCircle,
  faChevronCircleUp,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faClipboard, faClipboardCheck,
  faClose,
  faCogs,
  faComment,
  faCommentDots,
  faComments,
  faDisplay,
  faEarthAmericas,
  faEdit,
  faEraser,
  faExchangeAlt,
  faExclamation,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileCircleCheck,
  faFileCircleExclamation,
  faFileDownload,
  faFileLines,
  faFileUpload,
  faFileZipper,
  faFilter,
  faFolder,
  faFolderPlus,
  faGear,
  faGlobe,
  faGripLinesVertical,
  faHistory,
  faHome, faHourglassEmpty,
  faHouse,
  faHouseUser,
  faKey,
  faList,
  faLock,
  faMailBulk,
  faMessage,
  faPaperclip,
  faPencil,
  faPlus,
  faPlusCircle,
  faPrint,
  faRecycle,
  faRightToBracket,
  faSave,
  faSearch,
  faShield,
  faShieldAlt,
  faShieldHalved,
  faShip,
  faSignOutAlt,
  faSpinner,
  faStar,
  faStepBackward,
  faStepForward,
  faStickyNote,
  faSync,
  faSyringe,
  faTachometerAlt,
  faThList,
  faTimes,
  faTrash,
  faUndo,
  faUpload,
  faUser,
  faUserFriends,
  faUserLock,
  faUserPlus,
  faUserShield,
  faUserTie,
  faUserTimes,
  faVideo,
  faFileExcel, faFileWord,
  faFilePdf, faFileCirclePlus, faFolderOpen, faMinus, faMagnifyingGlassPlus, faMagnifyingGlassMinus, faExpand,
} from '@fortawesome/free-solid-svg-icons';
import {faBrain} from "@fortawesome/free-solid-svg-icons/faBrain";
import {faCompress} from "@fortawesome/free-solid-svg-icons/faCompress";

export const IconConfig = {
  config() {
    library.add(
        faCircle, faArchive, faComment, faRightToBracket,
        faEyeSlash, faEye, faStepBackward, faStepForward,
        faBars, faUserFriends, faBookmark, faHome,
        faAngleDown, faCogs, faChartArea,
        faEdit, faBookmark, faFileDownload, faFileUpload, faFile, faUndo, faPrint,
        faBook, faTimes, faSignOutAlt,
        faArrowsAltH, faArrowsAltH, faSave, faBan, faSearch,
        faPlus, faCheck, faExchangeAlt, faTrash,
        faArrowRight, faExclamation, faComments, faCommentDots, faCaretDown,
        faCaretUp, faUserPlus, faPaperclip,
        faTachometerAlt, faAsterisk, faMailBulk, faBell, faUserTie,
        faSpinner, faFilter,
        faUpload, faUserTimes, faPlusCircle, faChevronCircleUp, faSync,
        faCheckCircle, faKey, faUserLock,
        faSyringe, faHouseUser, faUserShield, faHistory, faClipboard, faShieldAlt,
        faRecycle, faFileAlt, faPencil, faShip, faMessage, faFileLines, faEraser, faCaretRight,
        faFolderPlus, faArrowLeft, faList, faThList, faEarthAmericas, faStar, faGlobe, faUser,
        faFolder, faFileZipper, faArrowDownShortWide, faClose, faLock, faShield,
        faArrowRightToBracket, faArrowRightFromBracket, faGear, faVideo, faStickyNote, faHouse,
        faDisplay, faAnglesDown,
        faChartColumn, faArrowUpFromBracket, faShieldHalved, faArrowRightLong, faArrowLeftLong,
        faChevronRight,
        faChevronLeft, faGripLinesVertical, faArrowsLeftRightToLine, faFileCircleCheck,
        faFileCircleExclamation, faClipboardCheck, faHourglassEmpty, faEyeSlash, faChevronLeft,faFilePdf,
        faFileCirclePlus,
        faFolderOpen,faMinus,faMagnifyingGlassPlus,faMagnifyingGlassMinus,
        faFileExcel, faFileWord,faBrain,faSearch,faExpand,faCompress
    );
  },
};

export default {IconConfig};
